export const EXCLUDED_COUNTRIES = ['uk', 'eu', 'ap', 'ru', 'kp', 'ir'];